import { Endpoint } from '../endpoint';
import { UserId, UserSocialId, UserSocialAccountResponse } from '@business/entities/account';
import { CalendarEventResponse, CalendarResponse, EventMeta } from '@business/entities/calendar';
import { RecursivePartial } from '@core/utils/react';
import { SchedularForData } from '@modules/CalendarPage/AddSchedularModal/AddSchedularModal';
import { UserScheduleResponse } from '@business/entities/account/UserScheduleResponse';
import { R } from '@core/utils/r';

export function list(socialId: UserId) {
  return Endpoint.get<CalendarResponse[]>(`@gc/calendar`, { params: { socialId } });
}

export function events(socialIds: UserSocialId[], startDate: number, endDate: number, participent?: string) {
  return Endpoint.get<CalendarEventResponse[]>(`@gc/calendar/events`, { params: R.objectCompact({ socialIds, startDate, endDate, participent }) });
}

export function addSchedule(socialId: UserSocialId, data: SchedularForData, id?: string) {
  return Endpoint.post<UserScheduleResponse[]>(`@gc/calendar/schedule`, { data: { socialId, data, id: id || '' } });
}

export function listSchedule(socialId: UserSocialId) {
  return Endpoint.get<UserScheduleResponse[]>(`@gc/calendar/schedule`, { params: { socialId } });
}

export function deleteSchedule(socialId: UserSocialId, scheduleId: string) {
  return Endpoint.delete<UserScheduleResponse[]>(`@gc/calendar/schedule/${scheduleId}`, { params: { socialId } });
}

export function getPublicSlug(shortId: string, uname: string, slug: string) {
  return Endpoint.get<{ slug: string }>(`@gc/public/calendar/${shortId}/${uname}`, { params: { slug } });
}

export function getSocials() {
  return Endpoint.get<UserSocialAccountResponse[]>(`@gc/calendar/socials`);
}

/* Events API */

export function addEvent(socialId: UserSocialId, event: RecursivePartial<CalendarEventResponse>, meta?: EventMeta) {
  return Endpoint.post<CalendarEventResponse>(`@gc/calendar/event`, { data: R.objectCompact({ socialId, event: JSON.stringify(event), meta }) });
}

export function editEvent(socialId: UserSocialId, event: RecursivePartial<CalendarEventResponse>, eventId: string) {
  return Endpoint.patch<CalendarEventResponse>(`@gc/calendar/event`, { data: R.objectCompact({ socialId, event: JSON.stringify(event), eventId }) });
}

export function deleteEvent(calendarId: string, eventId: string) {
  return Endpoint.delete<CalendarEventResponse>(`@gc/calendar/event/${calendarId}/${eventId}`);
}
